import { Box, Typography } from '@mui/material'
import PageHero from '../components/common/PageHero'
import { PageContainer } from '../components/common/PageContainer'
import FeatureCard from '../components/common/FeatureCard'
import BulletListSection from '../components/common/BulletListSection'
import PrimaryButton from '../components/common/PrimaryButton'
import { MOBILE_MQ, mobileBodyTextSx } from '../theme/mobileLayout'
import activityExpertSessions from '../assets/icons/events/activity-expert-sessions.png'
import activityWorkshops from '../assets/icons/events/activity-workshops.png'
import activityTeamBuilding from '../assets/icons/events/activity-team-building.png'
import activityCertification from '../assets/icons/events/activity-certification.png'

const highlights = [
  {
    title: 'Keynote Speakers',
    iconSrc: activityExpertSessions,
    iconBgColor: 'rgba(183,142,7,0.12)',
  },
  {
    title: 'Panel Discussions',
    iconSrc: activityWorkshops,
    iconBgColor: 'rgba(183,7,7,0.12)',
  },
  {
    title: 'Networking Sessions',
    iconSrc: activityTeamBuilding,
    iconBgColor: 'rgba(115,183,7,0.12)',
  },
  {
    title: 'Youth Awards',
    iconSrc: activityCertification,
    iconBgColor: 'rgba(7,183,183,0.12)',
  },
]

const summitItems = [
  'Inspiring keynote addresses by national leaders',
  'Interactive panel discussions on youth leadership',
  'Networking with peers from across India',
  'Recognition of outstanding youth contributors',
  'Workshops on leadership and nation building',
  'Cultural performances and community engagement',
]

export default function YouthSummitPage() {
  return (
    <Box>
      <Box
        sx={{
          minHeight: { xs: 400, md: 600 },
          display: 'flex',
          alignItems: 'center',
          bgcolor: '#082753',
        }}
      >
        <PageContainer>
          <PageHero
            title="Youth Leadership Summit"
            subtitle="Annual gathering of young leaders committed to building a stronger India"
            centered
            light
          />
        </PageContainer>
      </Box>

      <PageContainer sx={{ py: { xs: '80px', md: 12 } }}>
        <Typography sx={{ ...mobileBodyTextSx, lineHeight: 1.6, mb: 6, maxWidth: 1000 }}>
          The Youth Leadership Summit brings together young leaders from across India for a day of
          inspiration, learning, and collaboration. Featuring renowned speakers, panel discussions,
          networking opportunities, and recognition of outstanding youth contributors to society.
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(2, 1fr)' },
            gap: 2,
            mb: 8,
            [MOBILE_MQ]: { gridTemplateColumns: '1fr' },
          }}
        >
          {highlights.map((h) => (
            <FeatureCard key={h.title} {...h} />
          ))}
        </Box>

        <BulletListSection title="Summit Highlights" items={summitItems} />

        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <PrimaryButton to="/contact">
            Register for Summit
          </PrimaryButton>
        </Box>
      </PageContainer>
    </Box>
  )
}
